import { createContext, useContext } from 'react';

const LoginLocalInfoContext = createContext();

export const LoginLocalInfoContextProvider = LoginLocalInfoContext.Provider;
export const useLocalLoginInfo = () => useContext(LoginLocalInfoContext);
